import { install } from "vue3-recaptcha-v2";

export default defineNuxtPlugin((nuxtApp) => {
    const runTimeConfig = useRuntimeConfig();
    
    nuxtApp.vueApp.use(install, {
        sitekey: `${runTimeConfig.public.recaptchaSiteKey}`,
        cnDomains: false,
  });
});